import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }
    formData.delete('phone_alt');

    setStatus('submitting');
    try {
      const response = await fetch('https://readdy.ai/api/form/d9pmgmub4qjhggaeq16g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* raw text */ }

      if (response.ok && parsed && (parsed as { code?: string }).code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们会定期发送最新教程和资讯到您的邮箱。');
        setEmail('');
      } else {
        const serverMsg = (parsed as { meta?: { message?: string; detail?: string }; message?: string })?.meta?.message
          || (parsed as { message?: string })?.message
          || responseText;
        if (typeof serverMsg === 'string' && serverMsg.includes('spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后再试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
          订阅新闻简报
        </h2>
        <p className="text-foreground-600 mb-8">
          订阅我们的新闻简报，第一时间获取91网页版入口最新地址、更新公告和使用教程
        </p>

        <form
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <div className="honeypot-field">
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 disabled:opacity-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {status === 'submitting' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-accent-600">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-500">{message}</p>
        )}

        <p className="mt-4 text-xs text-foreground-400">
          我们尊重您的隐私，不会向第三方泄露您的邮箱地址
        </p>
      </div>
    </section>
  );
}